import { ViewerLinkApi, useAPIQuery } from "melco-shared-logic";

export const useViewerLink = (
  viewId: string | null | undefined
) => {
  return useAPIQuery(
    ViewerLinkApi,
    ["viewerLink", viewId],
    async (api) => {
      if (viewId == null || viewId == undefined) {
        return;
      }

      return await api.statisticalViewerLinkGet({ id: viewId });
    }
  );
};